import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'

type UseDeleteAreaMutation = {
	onSettled: () => void
}

export const useDeleteAreaMutation = ({ onSettled }: UseDeleteAreaMutation) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: deleteAreaMutation } = useMutation({
		mutationFn: (id: number | null) => {
			return axiosPrivate.delete(apiRoutes.area(id?.toString() as string))
		},
		onSuccess: () => {
			useToast({ type: 'success', message: t('Area deleted') })()
			queryClient.invalidateQueries({ queryKey: queryKeys.booths.all })
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		deleteAreaMutation
	}
}
